export default __webpack_public_path__ + "static/media/play.e1792e04.svg";